<template>
  <div class="highlights">
    <div
      v-if="highlightsTitle || highlightsDescription"
      class="highlights-intro space-y-5 md:space-y-12"
      :class="highlightsWithLinks ? 'text-left' : 'text-center'"
    >
      <h2
        v-if="highlightsTitle"
        class="text-4xl font-bold lg:mb-16"
      >
        {{ highlightsTitle }}
      </h2>
      <p
        v-if="highlightsDescription"
        class="text-base"
      >
        {{ highlightsDescription }}
      </p>
    </div>
    <template v-if="highlightsWithLinks">
      <ul class="highlights-list grid grid-cols-1 lg:grid-cols-2 gap-12">
        <li
          v-for="(highlight, i) in highlights"
          :key="i"
          class="highlights-list-item gap-4 flex flex-row items-start justify-start w-full"
        >
          <img
            v-if="highlight.image"
            class="highlights-list-image mb-7 w-32 h-32"
            :src="highlight.image"
            :alt="highlight.alt"
          >
          <div>
            <h3
              v-if="highlight.title"
              class="highlights-list-title mb-2 text-black text-left text-xl font-semibold"
            >
              {{ highlight.title }}
            </h3>
            <p
              v-if="highlight.description"
              class="highlights-list-description text-left text-base"
            >
              {{ highlight.description }}
            </p>

            <KfLink
              v-if="highlight.link && highlight.link.url"
              :href="highlight.link.url"
              class="font-medium "
            >
              <span class="flex w-fit flex-row justify-center items-center gap-3">{{ highlight.link.text }}
                <div class="w-4 h-4">
                  <ArrowRight class="w-full h-full" />
                </div>
              </span>
            </KfLink>
          </div>
        </li>
      </ul>
    </template>
    <template v-else>
      <ul class="highlights-list flex flex-wrap justify-center gap-12">
        <li
          v-for="(highlight, i) in highlights"
          :key="i"
          class="highlights-list-item flex flex-col items-center justify-start w-[320px]"
        >
          <img
            v-if="highlight.image"
            class="highlights-list-image mb-7 w-32 h-32"
            :src="highlight.image"
            :alt="highlight.alt"
          >
          <h3
            v-if="highlight.title"
            class="highlights-list-title mb-2 text-black text-center text-xl font-semibold"
          >
            {{ highlight.title }}
          </h3>
          <p
            v-if="highlight.description"
            class="highlights-list-description text-center text-base"
          >
            {{ highlight.description }}
          </p>
        </li>
      </ul>
    </template>
  </div>
</template>

<script>
import KfLink from '@/components/base/link/Link.vue';

export default {
  name: 'KfHighlightsList',
  components: {
    KfLink,
    ArrowRight: () => import(/* webpackChunkName: "main"*/ '@/components/svg/ArrowRight.vue'),
  },
  props: {
    highlightsTitle: {
      type: String,
      default: '',
    },
    highlightsDescription: {
      type: String,
      default: '',
    },
    highlights: {
      type: Array,
      default: () => [],
    },
    btnAlignmentHorizontal: {
      type: Boolean,
      default: false,
    },
    highlightsWithLinks: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
